import axios from "axios";
import { globalAction } from "redux-subspace";

import { tokenType, tokenStatus, RecoverPasswordType } from "./constants";
import { getTranslatedText } from "./utils";

const RECOVERY_PASSWORD = "RECOVERY_PASSWORD";
const CHANGE_PASSWORD = "CHANGE_PASSWORD";
const VALIDATE_PASSWORD = "VALIDATE_PASSWORD";
const RECOVERY_ERROR = "RECOVERY_ERROR";
const CHANGE_ERROR = "CHANGE_ERROR";
const SET_PASSWORD = "SET_PASSWORD";
const SET_CONFIRM_PASSWORD = "SET_CONFIRM_PASSWORD";
const SET_TOKEN_VALID = "SET_TOKEN_VALID";
const RESET_SUBMIT_STATE = "RESET_SUBMIT_STATE";
const RESET_SUBMITTED_CHANGE = "RESET_SUBMITTED_CHANGE";
const RESET_ERROR_MESSAGE = "RESET_ERROR_MESSAGE";
const RESET_STATE = "RESET_STATE";

const initialState = {
  submittedRecover: false,
  submittedChange: false,
  password: null,
  confirmPassword: null,
  canSubmit: false,
  error: null,
  errorMessage: null,
  isTokenValid: "",
};

export default function recoveryReducer(state = initialState, action) {
  switch (action.type) {
    case RECOVERY_PASSWORD:
      return {
        ...state,
        submittedRecover: true,
      };
    case RESET_SUBMIT_STATE:
      return {
        ...state,
        submittedRecover: false,
      };
    case RESET_SUBMITTED_CHANGE:
      return {
        ...state,
        submittedChange: false,
      };
    case CHANGE_PASSWORD:
      return {
        ...state,
        submittedChange: true,
      };
    case RECOVERY_ERROR:
      return {
        ...state,
        error: action.data.error,
        errorMessage: getTranslatedText(action.data.error?.response?.data),
        submittedRecover: false,
      };
    case CHANGE_ERROR:
      return {
        ...state,
        error: action.data.error,
        errorMessage: getTranslatedText(action.data.error?.response?.data),
        submittedChange: false,
      };
    case RESET_ERROR_MESSAGE:
      return {
        ...state,
        errorMessage: null,
      };
    case VALIDATE_PASSWORD:
      return {
        ...state,
        canSubmit: action.data.canSubmit,
      };
    case SET_PASSWORD:
      return {
        ...state,
        password: action.data.password,
      };
    case SET_CONFIRM_PASSWORD:
      return {
        ...state,
        confirmPassword: action.data.confirmPassword,
      };
    case SET_TOKEN_VALID:
      return {
        ...state,
        isTokenValid: action.data.isTokenValid,
      };
    case RESET_STATE:
      return initialState;
    default:
      return state;
  }
}

export const recover = (email) => async (dispatch) => {
  try {
    await axios.post(`/api/account/recoverpassword`, {
      Email: email,
      RecoverPasswordType: RecoverPasswordType.forgotPassword,
    });
    return dispatch(
      globalAction({
        type: RECOVERY_PASSWORD,
      })
    );
  } catch (error) {
    return dispatch(
      globalAction({
        type: RECOVERY_ERROR,
        data: { error },
      })
    );
  }
};

export const change =
  (token, username, agreement = false) =>
  async (dispatch, getState) => {
    try {
      const { password } = getState().recoveryReducer;
      await axios.post(`/api/account/recoverchangepassword`, {
        Token: token,
        Username: username,
        Password: password,
        AcceptedTerms: agreement,
      });
      return dispatch(
        globalAction({
          type: CHANGE_PASSWORD,
        })
      );
    } catch (error) {
      return dispatch(
        globalAction({
          type: RECOVERY_ERROR,
          data: { error },
        })
      );
    }
  };

export const validate = () => (dispatch, state) => {
  const { password, confirmPassword } = state().recoveryReducer;
  const canSubmit =
    password !== null &&
    confirmPassword !== null &&
    password.localeCompare(confirmPassword) === 0;
  return dispatch(
    globalAction({
      type: VALIDATE_PASSWORD,
      data: { canSubmit },
    })
  );
};

export const setPassword = (password) => (dispatch) => {
  return dispatch(
    globalAction({
      type: SET_PASSWORD,
      data: { password },
    })
  );
};

export const setConfirmPassword = (confirmPassword) => (dispatch) => {
  return dispatch(
    globalAction({
      type: SET_CONFIRM_PASSWORD,
      data: { confirmPassword },
    })
  );
};

export const resetSubmitState = () => (dispatch) => {
  return dispatch(
    globalAction({
      type: RESET_SUBMIT_STATE,
    })
  );
};

export const resetSubmittedChangeState = () => (dispatch) => {
  return dispatch(
    globalAction({
      type: RESET_SUBMITTED_CHANGE,
    })
  );
};

export const resetErrorMessage = () => (dispatch) => {
  return dispatch(
    globalAction({
      type: RESET_ERROR_MESSAGE,
    })
  );
};

export const verifyToken = (token) => (dispatch, state) => {
  const { isTokenValid } = state().recoveryReducer;
  if (isTokenValid === "") {
    axios
      .post(`/api/account/validatetoken`, {
        Token: token,
        TokenType: tokenType.password,
      })
      .then((r) => {
        const isTokenValid = r.data.TokenStatus === tokenStatus.valid;
        return dispatch(
          globalAction({
            type: SET_TOKEN_VALID,
            data: { isTokenValid },
          })
        );
      })
      .catch((error) => {
        return dispatch(
          globalAction({
            type: RECOVERY_ERROR,
            data: { error },
          })
        );
      });
  }
};

export const resetState = () => (dispatch) => {
  return dispatch(
    globalAction({
      type: RESET_STATE,
    })
  );
};

export const mapStateToPropsRecovery = (state) => {
  const {
    submittedRecover,
    submittedChange,
    canSubmit,
    password,
    error,
    errorMessage,
    isTokenValid,
  } = state.recoveryReducer;
  return {
    submittedRecover,
    submittedChange,
    canSubmit,
    password,
    error,
    errorMessage,
    isTokenValid,
  };
};

export const mapDispatchToPropsRecovery = {
  recover,
  change,
  validate,
  setPassword,
  setConfirmPassword,
  verifyToken,
  resetSubmitState,
  resetSubmittedChangeState,
  resetErrorMessage,
  resetState,
};
